import React, { useCallback, useState } from "react";
import { useUnit } from "effector-react";
import { useNavigate, useLocation, Link } from "react-router-dom";
import { Badge } from "primereact/badge";
import { $authStore, logoutRequested } from "@/features/auth/store/auth";
import { ROUTES } from "@/core/constants/app";
import "./Header.scss";
import { imageList } from "@/core/utils/imageList";
import { Upgrade } from "./components/Upgrade";
import { MobileNav } from "./components/MobileNav";
import { $unreadNotificationsCount } from "@/features/notifications";

const Header: React.FC = () => {
  return (
    <header className="app-header">
      <Link to={"/"} className="logo">
        <img src={imageList.logo} alt="EU Calls" />
      </Link>
      <Upgrade />
      <MobileNav />
    </header>
  );
};

export default Header;
